import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_16e527 = setTheme(({ theme }) => `background-color: ${theme.colors.color_16e527}`);
